import React from "react";
import { ThemeProvider, createGlobalStyle } from "styled-components";

import { normalize } from "styled-normalize";

import Theme from "@theme";

import { SkeletonTheme } from "react-loading-skeleton";

import "react-loading-skeleton/dist/skeleton.css";
import { ApolloClientContext } from "@contexts";

interface IProps {
  element: React.ReactNode;
}

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, nav, section {
    display: block;
  }

  body {
    line-height: 1;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  ${normalize}
  
  * {
    box-sizing: border-box;
  }

  html {
    font-size: "100%"; // 16px
  }
  
  body {
    width: 100%;
    height: 100vh;
    font-family: ${Theme.fonts.regular}, Lucida Grande, Calibri;
    margin: 0;
  }

  strong {
    font-family: ${Theme.fonts.bold};
  }

  h1 {
    margin: 0;
  }
  
  em {
    font-style: italic;
  }

  body.mobile-navbar-open {
    overflow: hidden;
  }

  ol {
    padding-inline-start: 1rem;
  }
  
  ul {
    padding-inline-start: 2rem;
  }
`;

const RootElement = ({ element }: IProps) => {
  return (
    <ApolloClientContext>
      <ThemeProvider theme={Theme}>
        <GlobalStyle />
        <SkeletonTheme>{element}</SkeletonTheme>
      </ThemeProvider>
    </ApolloClientContext>
  );
};

export default RootElement;
